import React from 'react';

/**
 * WaitlistTableSkeleton - Loading skeleton for WaitlistManager entries
 * Displays placeholder rows while waitlist manager data is loading
 */
function WaitlistTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="bg-white border border-gray-200 rounded-lg p-4 animate-pulse"
        >
          <div className="flex items-center justify-between gap-4">
            {/* Vendor info */}
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-gray-200 rounded w-1/3"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>

            {/* Position badge */}
            <div className="h-8 w-16 bg-gray-200 rounded-full"></div>

            {/* Status badge */}
            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>

            {/* Actions */}
            <div className="flex gap-2">
              <div className="h-8 w-8 bg-gray-200 rounded"></div>
              <div className="h-8 w-8 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default WaitlistTableSkeleton;
